
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import { ISupplier } from '@/utils/types/model/supplier'

interface ITableColumn {
  prop: string
  label: string
  sortable?: boolean | string
  width?: number
}

@Options({
  name: 'SupplierList',
  emits: ['sort-change'],
})
export default class SupplierList extends Vue {
  @Prop({ type: Array, default: () => [] }) suppliersData!: ISupplier[]

  get tableColumns(): ITableColumn[] {
    return [
      { prop: 'supplierCode', label: this.$t('suppliers.supplier_code'), sortable: 'custom' },
      { prop: 'name1', label: this.$t('suppliers.supplier_name'), sortable: 'custom' },
      { prop: 'address1', label: this.$t('suppliers.address') },
      { prop: 'postalCode', label: this.$t('suppliers.postal_code') },
      { prop: 'phoneNumber', label: this.$t('suppliers.phone_number') },
      { prop: 'companyCode', label: this.$t('suppliers.company_code'), width: 150 },
    ]
  }

  handleSortChange(data: { prop: string; order: string | null }) {
    this.$emit('sort-change', data)
  }
}
